export class RelatorioMovimentacoes {
  constructor({
    unidade,
    funcionario,
    ferramenta,
    descricao,
    patrimonio,
    permanencia,
    checkLists,
    dataInicialRetirada,
    dataFinalRetirada,
    dataInicialDevolucao,
    dataFinalDevolucao,
    preco,
  }) {
    this.unidade = unidade;
    this.funcionario = funcionario;
    this.ferramenta = ferramenta;
    this.descricao = descricao;
    this.patrimonio = patrimonio;
    this.permanencia = permanencia;
    this.checkLists = checkLists;
    this.dataInicialRetirada = dataInicialRetirada;
    this.dataFinalRetirada = dataFinalRetirada;
    this.dataInicialDevolucao = dataInicialDevolucao;
    this.dataFinalDevolucao = dataFinalDevolucao;
    this.preco = preco;
  }
}
